import { render, staticRenderFns } from "./PrfPackingRptSenasa.vue?vue&type=template&id=40c91aa0"
import script from "./PrfPackingRptSenasa.vue?vue&type=script&lang=js"
export * from "./PrfPackingRptSenasa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports